import React from 'react';

const Dashboard = () => (<div>Not found</div>);

export default Dashboard;